export const matomoTrackEvent = ({
  category,
  action,
  name,
  value,
}: {
  category: string;
  action: string;
  name: string;
  value?: unknown;
}) => {
  if (window?._paq) {
    window._paq.push(["trackEvent", category, action, name, value]);
  }
};
